import { apiRequest } from "./apiClient";

export const submitContactEnquiry = async (payload) => {
 const data = await apiRequest("/contact", {
  method: "POST",
  body: JSON.stringify({ customer: payload }),
 });

 return {
  ok: true,
  referenceId: data.enquiry?.enquiryId,
  enquiry: data.enquiry,
 };
};
